import ProjectsTable from '@/app/projects'
import { ability } from '@/casl/ability'
import TableSkeleton from '@/components/table-skeleton'
import { getFirstAccessibleRoute } from '@/constants/Auth'
import { companyByIdQueryOptions } from '@/hooks/useCompaniesQuery'
import LocalStorage from '@/utilities/LocalStorage'
import { createFileRoute, redirect } from '@tanstack/react-router'

const RouteComponent = () => {
  return <ProjectsTable />
}

export const Route = createFileRoute('/_auth/_withProject/projects')({
  beforeLoad: ({ context }) => {
    if (ability && context.auth.user && !ability.can('read', 'Talep')) {
      // toast.error("Bu sayfayı görüntüleme izniniz yok.")
      const permissions = context.auth.user.permissions || []
      const redirectPath = getFirstAccessibleRoute(permissions)
      throw redirect({
        to: redirectPath,
      })
    }
  },
  loader: async ({ context }) => {
    const { queryClient } = context

    const companyId = LocalStorage.selectedCompany()?.id

    await queryClient.fetchQuery(companyByIdQueryOptions(companyId))
    return {}
  },
  pendingComponent: TableSkeleton,
  component: RouteComponent,
})


